import {
    Wrapper,
    PartnerWrapper,
    PartnerTitle,
    PartnersContainer,
} from './styles';
import Image from 'next/image';
import { getImageBasePath } from '@utils/generics';

interface IProps {
    isMobile: boolean;
}

const partnerBrands = [
    {
        name: 'Amazon',
        path: '/images/partners/amazon.svg',
    },
    {
        name: 'Hdfc',
        path: '/images/partners/hdfc.svg',
    },
    {
        name: 'Ola',
        path: '/images/partners/ola.svg',
    },
    {
        name: 'Swiggy',
        path: '/images/partners/swiggy.svg',
    },
    {
        name: 'Cred',
        path: '/images/partners/cred.svg',
    },
    {
        name: 'MoneyTap',
        path: '/images/partners/moneytap.svg',
    },
    {
        name: 'Goibibo',
        path: '/images/partners/goibibo.svg',
    },
    {
        name: 'Zomato',
        path: '/images/partners/zomato.svg',
    },
];

const Partners = ({ isMobile }: IProps) => {
    return (
        <Wrapper>
            <PartnerWrapper>
                <PartnerTitle>Our Partners</PartnerTitle>
                <PartnersContainer>
                    {partnerBrands?.map((partner) => {
                        return (
                            <div key={partner?.name}>
                                <Image
                                    src={getImageBasePath(partner?.path)}
                                    width={isMobile ? '70px' : '130px'}
                                    height={isMobile ? '24px' : '42px'}
                                    alt={partner?.name}
                                />
                            </div>
                        );
                    })}
                </PartnersContainer>
            </PartnerWrapper>
        </Wrapper>
    );
};

export default Partners;
